const VenezuelaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112773)">
      <path
        d="M38.0155 28.6958C39.287 26.0664 40 23.1167 40 20.0002C40 16.8837 39.287 13.9339 38.0155 11.3046L20 9.56543L1.98453 11.3046C0.713047 13.9339 0 16.8837 0 20.0002C0 23.1167 0.713047 26.0664 1.98453 28.6958L20 30.435L38.0155 28.6958Z"
        fill="#0052B4"
      />
      <path
        d="M19.9998 39.9997C27.929 39.9997 34.7803 35.3852 38.0153 28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997Z"
        fill="#D80027"
      />
      <path
        d="M34.6381 23.9259L33.5818 24.7513L34.0402 26.0108L32.9287 25.2613L31.8723 26.0866L32.2417 24.798L31.1304 24.0483L32.4701 24.0016L32.8398 22.7129L33.2984 23.9726L34.6381 23.9259Z"
        fill="#F0F0F0"
      />
      <path
        d="M31.9333 19.2407L31.2231 20.3777L32.0849 21.4044L30.784 21.0805L30.0736 22.2171L29.9799 20.8799L28.6792 20.5554L29.9223 20.0532L29.8289 18.7158L30.6905 19.7429L31.9333 19.2407Z"
        fill="#F0F0F0"
      />
      <path
        d="M27.7885 15.7637L27.5099 17.075L28.6708 17.7453L27.3376 17.8859L27.0588 19.1968L26.5135 17.9723L25.1802 18.1122L26.1766 17.2152L25.6313 15.9906L26.7923 16.6608L27.7885 15.7637Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.7049 13.9131L22.8917 15.2407L24.2118 15.4733L23.0069 16.0613L23.1936 17.3888L22.2623 16.4244L21.0572 17.0121L21.6867 15.8282L20.7554 14.864L22.0757 15.0968L22.7049 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2954 13.9131L17.9248 15.0968L19.2448 14.8639L18.3138 15.8285L18.9429 17.0122L17.7381 16.4244L16.8067 17.3886L16.9935 16.0613L15.7886 15.4736L17.1088 15.2407L17.2954 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.2112 15.7637L13.2076 16.6608L14.3683 15.9906L13.8232 17.2156L14.8194 18.1125L13.4862 17.9723L12.9407 19.1968L12.6624 17.8856L11.3291 17.7456L12.49 17.0752L12.2112 15.7637Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.0667 19.2405L9.3099 19.7427L10.1713 18.7158L10.0781 20.0534L11.3209 20.5557L10.0202 20.8798L9.92654 22.2169L9.21639 21.0803L7.91553 21.4044L8.77725 20.3775L8.0667 19.2405Z"
        fill="#F0F0F0"
      />
      <path
        d="M5.3623 23.9257L6.7023 23.9724L7.16059 22.7129L7.53051 24.0016L8.87012 24.0484L7.75871 24.7981L8.12809 26.0867L7.07184 25.2614L5.96035 26.0109L6.41887 24.7512L5.3623 23.9257Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.0153 11.3044C34.7803 4.61445 27.929 0 19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0153Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112773">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VenezuelaSvg;
